import * as genericapi from './genericApi';
// Attach the generic API functions to the global object
global.genericapi = genericapi;
